<div fxLayoutAlign="start center">
  @if (params()?.value) {
    <span [style.color]="getApplicableScore($safeNavigationMigration(params()?.value)).color" class="address-accuracy-cell-value"
      >{{ $safeNavigationMigration(params()?.value) * 100 | numberFormat | infoDisplay }} %</span
    >
  } @else {
    <span class="address-accuracy-cell-value">-</span>
  }
</div>
